import { useContext, useState, useEffect } from 'react';
import { useHistory } from "react-router-dom"
import { Box } from '@mui/material';
import { ToolContext } from '../../../../../core/context/ToolContext';
import { Index as BranchProduct } from './branchProduct/Index';
import { Index as BranchSales } from './branchSales/Index';
import { Index as BranchOrder } from './branchOrder/Index';
import { Index as CustomerSales } from '../../../billout/desktop/Index';

export const Index = ({match}) => {
    let loc = match.params.features
    const { tool_state, } = useContext(ToolContext)
    const { compInfo } = {...tool_state}

    const nature = compInfo.data[0]?.nature_id
    const nav = useHistory()
    const [tabs, setTabs] = useState([
        {name:'Branch Product', ref:'branch-product'},
        {name:'Branch Sales', ref:'branch-sales'},
        {name:'Customer Sales', ref:'customer-sales'},
        {name:'Branch Order', ref:'branch-order'}
    ])

    const redirectHandler = async(ref) => {
        if (ref !== loc) {
            nav.push(`/reports/${ref}`)        
        }
    }

    useEffect(() => {
        if (nature !== 23) {
            setTabs(tabs.filter((v) => v.name !== 'Customer Sales'));
        }
        //eslint-disable-next-line
    }, []);

    return (
        <Box display="flex" flexDirection="column" width="100%" height="100%">

        <Box display="flex" gap={2} borderBottom="1px solid #E0E0E0" px={1} justifyContent="center" height="15%" minHeight={100}>
            {tabs?.map((v, k) => {
            const active = loc === v.ref;

            return (
                <Box
                key={k}
                onClick={() => redirectHandler(v.ref)}
                sx={{
                    mt: 8,
                    cursor: "pointer",
                    paddingY: "12px",
                    fontSize: "14px",
                    fontWeight: active ? 600 : 400,
                    color: active ? "primary.main" : "#6B7280",
                    borderBottom: active
                    ? "3px solid"
                    : "3px solid transparent",
                    borderColor: active ? "primary.main" : "transparent",
                    transition: "all 0.2s ease",
                    "&:hover": {
                    color: "primary.main",
                    },
                }}
                >
                {v.name}
                </Box>
            );
            })}
        </Box>

        <Box px={3} py={2} height="75%">
            <Components loc={loc} match={match} nature={nature} />
        </Box>
        </Box>
    )
}

const Components = ({loc, match, nature}) => {
    if (loc === 'branch-product') { return <BranchProduct match={match}/>
    }else if (loc === 'branch-sales') { return <BranchSales match={match}/>
    }else if (loc === 'customer-sales') { 
        return nature === 23 && <CustomerSales match={match}/>
    }else if (loc === 'branch-order') { return <BranchOrder match={match}/>
    }else{return 'NOT FOUND'}
}